import { Component } from '@angular/core';
import { GlobalsAction } from '../../state-management/globals/globals.action';
import { Store } from '@ngrx/store';

@Component({
    selector: 'hub-draggable',
    templateUrl: './hub-draggable.component.html',
    styleUrls: ['./hub-draggable.component.scss'],
})
export class HubDraggableComponent {
    constructor(private store: Store<any>) {}

    public closeDraggable() {
        this.store.dispatch({ type: GlobalsAction.attachLiveVideo });
    }
};
